import { Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import imageEmpty from 'src/assets/images/empty01.png';
import { Button } from 'src/@/components/ui/button';
const RootStyle = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  textAlign: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  // backgroundColor: theme.palette.background.neutral
}));

// ----------------------------------------------------------------------

EmptyContentGhost.propTypes = {
  title: PropTypes.string.isRequired,
  img: PropTypes.string,
  description: PropTypes.string
};

export default function EmptyContentGhost({ title, description, button, img, ...other }) {
  return (
    <RootStyle {...other}>
      <Box
        component="img"
        alt="empty content"
        src={img || imageEmpty}
        sx={{ height: 200, mb: 3 }}
      />

      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>

      {description && (
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {description}
        </Typography>
      )}

      {button && button.admin && (
        button.user.level === "root" ?
          <div className="mt-5">

            <Button
              onClick={button.onClick}
              className="bg-violet-700"
            >
              {button.label}
            </Button>

          </div> : null
      )}

      {button && !button.admin && (
        <div className="mt-5">

          <Button
            onClick={button.onClick}
            className="bg-violet-700"
          >
            {button.label}
          </Button>

        </div>
      )}
    </RootStyle>
  );
}
